// Function loadBioListItem loads the BioListItem class by dynamically importing the js on demand if needed

export function loadBioListItem($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-bio-list-item-chunk" */ '../widgets/bioListItem').then(wg => {

		const { BioListItem } = wg;

		let $wg = $parentEl.querySelector('[data-wg="BioListItem"]');

		if(!$wg) {
			// console.info('BioListItem: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="BioListItem"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new BioListItem($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new BioListItem($wg);
		}


	}).catch(error => error+'An error occurred while loading the BioListItem widget');

}
